import { isWebConfig } from './lib/utils';
import Dashboard from './screens/dashboard';
import Loyalty from './screens/loyalty';
import Account from './screens/account';
import Feedback from './screens/feedback';
import ReferAFriend from './screens/referAFriend';
import History from './screens/history';
import HistoryDetails from './screens/historyDetails';
import Locations from './screens/locations';
import Social from './screens/social';
import Login from './screens/login';
import Register from './screens/register';
import ResetPassword from './screens/resetPassword';
import Terms from './screens/terms';
import Privacy from './screens/privacy';
import Faq from './screens/faq';
import ItemDetails from './screens/itemDetails';
import DeliveryOptions from './screens/delivery-options';
import Delivery from './screens/delivery';
import DeliveryAddressCheck from './screens/delivery-address-check';
import DeliveryAddressAdd from './screens/delivery-address-add';
import DeliveryTime from './screens/delivery-time';
import ClickAndCollect from './screens/clickAndCollect';
import Cards from './screens/cards';
import CardAdd from './screens/cardAdd';
import OrderSummary from './screens/orderSummary';
import ApplyPoints from './screens/applyPoints';
import Checkout from './screens/checkout';
import OrderCompletedKiosk from './screens/orderCompleted';
import ContactDetails from './screens/contactDetails';
import ApplyVouchers from './screens/applyVouchers';

// import AllergensInfo from './screens/allergensInfo'
import OrderToTable from './screens/orderToTable';
import { getConfig } from './appConfig';
import { getSingleDeliveryOption } from './lib/utils';
import { ServiceCharge } from './screens/service-charge';
import ApplyLoyalty from './screens/applyLoyalty';
import MyMembership from './screens/myMembership';
import MembershipCompleted from './screens/membershipCompleted';
import CheckoutMembership from './screens/checkoutMembership';
import CardAddMembersip from './screens/cardAddMembership';
import ChooseSubscriptionMenu from './screens/chooseSubscriptionMenu';
import ChooseSubscription from './screens/chooseSubscription';
import TermsAndConditions from './screens/terms-subscription-package';
import api from './lib/api';
import CreateAccount from './screens/createAccount';
import PayTableBill from './screens/payTableBill';
import PayTableOverview from './screens/payTableOverview';
import SplitBill from './screens/splitBill';
import SplitBillByAmount from './screens/splitBillByAmount';
import SplitBillByItems from './screens/splitBillByItems';
import BillCompleted from './screens/billCompleted';
import PickUpAtCounter from './screens/pickUpAtCounter';
import GiftVouchers from './screens/giftVouchers';
import SentGiftVouchers from './screens/sentGiftVouchers';
import GiftVoucherOverview from './screens/giftVoucherOverview';
import GiftBalance from './screens/giftBalance';
const Order = require('./screens/order' + (isWebConfig() ? 'Web' : '')).default;
import ScheduledDelivery from './screens/scheduled-delivery';
import ScheduledDeliveryTime from './screens/scheduled-delivery-time';
import nativeOrderStatus from './components/nativeOrderStatus';
import GiftCard from './screens/giftCard';
import Voucher from './screens/voucher';

let navConfig;

export const initRouter = async (config, clientId) => {
  const singleDeliveryOption = await getSingleDeliveryOption(config);
  const { hasBillPay, hasGiftVouchers, hasMembership, hasGuestCheckout, hasReferAFriend, hasOrdering, hasLoyalty, removeLocations, removeSocial, removeCustomerService } = config.front_end_app_config.flags;
  const customFeedbackLink = config.front_end_app_config?.general?.customFeedbackLink || false;
  const availableOrderModules = config.front_end_app_config?.delivery.filter((d) => !d.isRemoved && !d.isDisabled).map((el) => el.route);
  navConfig = {
    routes: [
      {
        label: 'Home',
        path: '/kiosk-dashboard',
        component: Dashboard,
        exact: true,
        default: true,
      },
      ...(hasOrdering
        ? [
          {
            label: 'Menu',
            path: '/order',
            component: Order,
            exact: true,
            group: 'button',
          },
        ]
        : []),
      ...(hasBillPay
        ? [
          {
            label: 'Pay Your Bill',
            path: '/table-bill-pay',
            component: PayTableBill,
            protected: false,
          },
        ]
        : []),

      {
        label: 'Apply Loyalty',
        path: '/apply-loyalty',
        component: ApplyLoyalty,
        protected: true,
        notInDrawer: true,
      },
      ...(hasMembership
        ? [
          {
            label: 'Membership',
            path: '/get-membership',
            component: ChooseSubscriptionMenu,
            protected: true,
            group: 2,
            activePaths: ['/my-membership']

          },
          {
            label: 'Membership',
            path: '/membership',
            component: ChooseSubscription,
            notInDrawer: true,
            protected: true,
            group: 2,

          },
        ]
        : []),
      {
        label: 'TermsAndConditions',
        path: '/membership-terms',
        component: TermsAndConditions,
        notInDrawer: true,
        protected: true,
      },
      {
        label: 'Checkout Membership',
        path: '/checkout-membership',
        component: CheckoutMembership,
        notInDrawer: true,
        protected: true,

      },
      {
        label: 'My Membership',
        path: '/my-membership',
        component: MyMembership,
        notInDrawer: true,
        protected: true,
        group: 2,

      },
      {
        label: 'Membership Completed',
        path: '/membership-completed',
        component: MembershipCompleted,
        notInDrawer: true,
        protected: false,
        group: 2,

      },
      {
        label: 'Add card Membership',
        path: '/add-card-membership',
        component: CardAddMembersip,
        notInDrawer: true,
        protected: true,
      },
      ...(hasOrdering
        ? [
          availableOrderModules.includes('/click-and-collect') && {
            label: singleDeliveryOption ? singleDeliveryOption.label : '',
            path: '/click-and-collect',
            component: ClickAndCollect,
            protected: false,
            notInDrawer: !singleDeliveryOption,
          },
          availableOrderModules.includes('/click-and-collect-scheduled') && {
            label: singleDeliveryOption ? singleDeliveryOption.label : '',
            path: '/click-and-collect-scheduled',
            component: ClickAndCollect,
            protected: false,
            notInDrawer: !singleDeliveryOption,
            scheduled: true,
          },
        ]
        : []),
      ...(hasOrdering
        ? [
          {
            label: 'Start New Order',
            path: '/delivery-options',
            component: DeliveryOptions,
            protected: false,
            notInDrawer: !!singleDeliveryOption,

          },
        ]
        : []),
      ...(hasLoyalty
        ? [
          {
            label: 'Loyalty',
            path: '/loyalty',
            component: Loyalty,
            protected: true,
            state: { tab: 'points' },
            group: 1,
          },
        ]
        : []),
      ...(hasReferAFriend
        ? [
          {
            label: 'Refer A Friend',
            path: '/refer-a-friend',
            component: ReferAFriend,
            protected: true,
            group: 1,
          },
        ]
        : []),
      ...(hasOrdering || hasGiftVouchers || hasMembership
        ? [
          {
            label: 'Checkout',
            path: '/checkout',
            component: Checkout,
            notInDrawer: true,
            protected: !hasGuestCheckout,
          },
        ]
        : []),
      ...(hasOrdering ? [
        {
          path: '/history-details',
          component: HistoryDetails,
          notInDrawer: true,
          group: 2
        }] : []),

      ...(hasOrdering
        ? [
          {
            label: 'Apply Points',
            path: '/apply-points',
            component: ApplyPoints,
            notInDrawer: true,
            protected: true,
          },
        ]
        : []),
      ...(hasOrdering
        ? [
          {
            label: 'Service Charge',
            path: '/service-charge',
            component: ServiceCharge,
            notInDrawer: true,
            protected: true,
          },
        ]
        : []),
      {
        label: 'My account',
        path: '/account',
        component: Account,
        protected: true,
        group: 2,
      },
      ...(hasGiftVouchers
        ? [
          {
            label: 'Send a voucher',
            path: '/gift-vouchers',
            component: GiftVouchers,
            protected: false,
            group: 4,
            activePaths: ['/gift-voucher']
          },
          {
            label: 'Check balance',
            path: '/voucher-balance',
            component: GiftBalance,
            protected: false,
            group: 4,
          },
          {
            label: 'Sent vouchers',
            path: '/sent-vouchers',
            component: SentGiftVouchers,
            protected: true,
            group: 4,
          },
          {
            path: '/gift-voucher',
            component: GiftVoucherOverview,
            protected: false,
            notInDrawer: true,
            group: 4,
          },
        ]
        : []),
      {
        label: 'History',
        path: '/history',
        component: History,
        protected: true,
        group: 2,
        activePaths: ['/history-details']

      },
      ...(customFeedbackLink
        ? [
          {
            label: 'Feedback',
            component: Feedback,
            protected: true,
            group: 2,
            isLink: true,
            path: customFeedbackLink,
          },
        ]
        : [
          {
            label: removeCustomerService ? 'Get support' : 'Leave feedback',
            path: '/feedback',
            component: Feedback,
            protected: true,
            group: 2,
          },
        ]),
      ...(!removeLocations
        ? [
          {
            label: 'Locations',
            path: '/locations',
            component: Locations,
            protected: false,
            group: 3,
          },
        ]
        : []),
      ...(!removeSocial
        ? [
          {
            label: 'Social media',
            path: '/social',
            component: Social,
            protected: false,
            group: 3,
          },
        ]
        : []),
      {
        label: 'Contact Details',
        path: '/contact-details',
        component: ContactDetails,
        protected: !hasGuestCheckout,
        notInDrawer: true,
      },
      {
        label: 'Apply Vouchers',
        path: '/apply-vouchers',
        component: ApplyVouchers,
        notInDrawer: true,
        protected: true,
      },
      {
        label: 'FAQ',
        path: '/faq',
        component: Faq,
        protected: false,
        notInDrawer: false,
        group: 3,
      },
    ],
    authRoutes: [
      { label: 'Login', path: '/login', component: Login, fn: 'login' },
      { label: 'Logout', path: '/logout', fn: 'logout' },
    ],
    additionalRoutes: [
      { label: 'T&Cs', path: '/terms', component: Terms, },
      { label: 'Privacy Policy', path: '/privacy', component: Privacy },
    ],
    notInMenuRoutes: [
      { path: '/register', component: Register },
      { path: '/create-account', component: CreateAccount },
      { path: '/reset-password', component: ResetPassword },
      { path: '/gift-card', component: GiftCard },
      { path: '/voucher', component: Voucher },

      ...(hasOrdering ? [{ path: '/order', component: Order }] : []),
      ...(hasOrdering ? [{ path: '/item-details', component: ItemDetails }] : []),
      ...(hasOrdering || hasGiftVouchers || hasMembership
        ? [{ path: '/cards', component: Cards }]
        : []),
      ...(hasOrdering || hasGiftVouchers || hasMembership
        ? [{ path: '/card-add', component: CardAdd }]
        : []),
      ...(hasOrdering ? [{ path: '/order-summary', component: OrderSummary }] : []),
      ...(hasOrdering ? [{ path: '/order-completed', component: OrderCompletedKiosk }] : []),
      ...(hasOrdering ? [{ path: '/order-status', component: nativeOrderStatus }] : []),
      ...(hasOrdering && availableOrderModules.includes('/order-to-table') ? [{ path: '/order-to-table', component: OrderToTable }] : []),
      ...(hasOrdering && availableOrderModules.includes('/delivery') ? [{ path: '/delivery', component: Delivery }] : []),
      ...(hasOrdering && availableOrderModules.includes('/scheduled-delivery') ? [{ path: '/scheduled-delivery', component: ScheduledDelivery }] : []),

      ...(hasOrdering
        ? [{ path: '/delivery-address-check', component: DeliveryAddressCheck }]
        : []),
      ...(hasOrdering ? [{ path: '/delivery-address-add', component: DeliveryAddressAdd }] : []),
      ...(hasOrdering ? [{ path: '/delivery-time', component: DeliveryTime }] : []),
      ...(hasOrdering ? [{ path: '/scheduled-delivery-time', component: ScheduledDeliveryTime }] : []),

      ...(hasOrdering && availableOrderModules.includes('/pick-up-at-counter') ? [{ path: '/pick-up-at-counter', component: PickUpAtCounter, protected: false }] : []),

      ...(hasOrdering ? [{ path: '/table-overview', component: PayTableOverview, protected: false }] : []),
      ...(hasOrdering ? [{ path: '/split-bill', component: SplitBill, protected: false }] : []),
      ...(hasOrdering ? [{ path: '/split-bill-by-amount', component: SplitBillByAmount, protected: false }] : []),
      ...(hasOrdering ? [{ path: '/split-bill-by-items', component: SplitBillByItems, protected: false }] : []),
      ...(hasOrdering ? [{ path: '/bill-completed', component: BillCompleted, protected: false }] : []),

    ],
  };

  return navConfig;
};

export default navConfig;
